angular
  .module('biz-ng-career-details')
  .constant('CareerDTD', {
    id: 'key',
    desc: {
      type: 'string',
      writeToKey: 'description'
    },
    name: 'string',
    ed_levels: {
      type: 'array',
      writeToKey: 'educationLevels'
    },
    onet: {
      type: 'integer',
      writeToKey: 'careerId'
    },
    exp_levels: {
      type: 'array',
      writeToKey: 'experienceLevels'
    },
    hiring_demand: 'string',
    salary_max: {
      type: 'integer',
      writeToKey: 'salaryMax'
    },
    salary_min: {
      type: 'integer',
      writeToKey: 'salaryMin'
    },
    skills: 'array'
  })
  .factory('CareerBuilder', function CareerBuilder(Interface, CareerDTD, numberFormatterFn) {
    function CareerDTO(data) {
      Interface.implement(CareerDTD, data, this);
      mapCareerData.call(this);
    }

    var mapCareerData = function mapCareerData() {
      function mapData(data) {
        var MAX_PERCENTAGE_INDEX = 1;
        // NOTE: `element` contains [0: name, 1: job percentage]
        var maxPercentage = _.reduce(
          data,
          function (maxPercentage, element) {
            return Math.max(maxPercentage, _.parseInt(element[MAX_PERCENTAGE_INDEX] || 0, 10));
          },
          0
        );
        return _.map(data, function (element) {
          return {
            label: element[0],
            value: _.parseInt(element[1]),
            units: '%',
            isMax: _.parseInt(element[MAX_PERCENTAGE_INDEX]) === maxPercentage
          };
        });
      }

      this.education = mapData(this.educationLevels);
      this.experience = mapData(this.experienceLevels);

      this.salaryMax = numberFormatterFn.convertToThousandsOfDollars(this.salaryMax);
      this.salaryMin = numberFormatterFn.convertToThousandsOfDollars(this.salaryMin);
    };

    return CareerDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/builders/career_builder.js